import { render } from "./approval-setting.vue?vue&type=template&id=685152fc"
import script from "./approval-setting.vue?vue&type=script&lang=js"
export * from "./approval-setting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__